import { faqData, rankingData, aboutData } from '@/mocks/homeData';
import { useState } from 'react';

export function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-question-answer-line text-primary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">常见问题</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">关于51吃瓜每日大赛，你想知道的都在这里</p>

          <div className="max-w-3xl space-y-3">
            {faqData.map((item) => (
              <div
                key={item.id}
                className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenId(openId === item.id ? null : item.id)}
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.q}</h3>
                  <span className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-transform duration-200 ${
                    openId === item.id ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-arrow-down-s-line text-sm"></i>
                  </span>
                </button>
                {openId === item.id && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5 pt-0">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-trophy-line text-accent-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">热度榜单</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">全网热议话题热度排名，实时更新</p>

          <div className="max-w-2xl">
            {rankingData.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-center gap-3 md:gap-4 py-3 md:py-4 ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-700 leading-snug">{item.title}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className={`text-xs ${
                    item.change === 'up' ? 'text-primary-500' : item.change === 'down' ? 'text-secondary-500' : 'text-accent-500'
                  }`}>
                    {item.change === 'up' && <i className="ri-arrow-up-line"></i>}
                    {item.change === 'down' && <i className="ri-arrow-down-line"></i>}
                    {item.change === 'new' && <i className="ri-sparkling-line"></i>}
                  </span>
                  <span className="text-xs font-semibold text-primary-500 whitespace-nowrap">{item.heat}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-information-line text-primary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">{aboutData.title}</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">了解我们的故事与使命</p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mb-8">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70">
                <p className="text-2xl md:text-3xl font-bold text-primary-500 font-heading mb-1">{stat.value}</p>
                <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="max-w-3xl space-y-4">
            {aboutData.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">{p}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}